import { Result, Spin } from 'antd';
import { SentryLoader } from 'App/components/SentryLoader';
import React, { useEffect, useState } from 'react';
import { ScaleLoader } from 'react-spinners';

interface IProps {
  phrases: string[];
  onAllPhrasesDisplayed?: () => void;
}

const LoadingMessage: React.FC<IProps> = ({
  phrases,
  onAllPhrasesDisplayed,
}) => {
  const [phraseIndex, setPhraseIndex] = useState(0);

  useEffect(() => {
    if (phrases.length == 0) {
      return;
    }

    const interval = setInterval(() => {
      setPhraseIndex((index) => {
        const nextIndex = (index + 1) % phrases.length;
        // Call callback in next tick to avoid updating parent during render
        if (index === phrases.length - 1 && onAllPhrasesDisplayed) {
          setTimeout(() => onAllPhrasesDisplayed(), 0);
        }
        return nextIndex;
      });
    }, 2000);

    return () => clearInterval(interval);
  }, [phrases, onAllPhrasesDisplayed]);

  return (
    <Result
      icon={<SentryLoader />}
      title={phrases.length > 0 ? phrases[phraseIndex] : 'Loading...'}
    />
  );
};

export { LoadingMessage };
